import React from "react";
import { FONTS } from "@app/constants";
import { Text } from "@/styles/reactnative";
import { WorldRankingItems } from "../styles";

const RankingSelectorItem = ({ item, index }: any) => {
  const textStyles = {
    ...FONTS.h7,
    background: "transparent",
    paddingBlock: 10,
    width: "13%",
    cursor: "pointer",
    justifyContent: "flex-start",
    paddingLeft: 5,
  };
  return (
    <WorldRankingItems>
      <Text style={{ ...textStyles, width: "5%" }}>{index + 1}</Text>
      <Text style={{ ...textStyles, width: "20%" }}>{item?.english_name}</Text>
      <Text style={textStyles}>{item?.korean_name}</Text>
      <Text style={textStyles}>{item?.market}</Text>
      <Text style={textStyles}>{index + 2 * 12}</Text>
      <Text style={textStyles}>{index + 2 * 15}</Text>
      <Text style={textStyles}>{index + 2 * 32}</Text>
      <Text style={textStyles}>{index + 2 * 32}</Text>
    </WorldRankingItems>
  );
};

export default React.memo(RankingSelectorItem);
